import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const CONSENT_KEY = "cookie_consent";

export type ConsentStatus = "granted" | "denied" | null;

export const getConsentStatus = (): ConsentStatus => {
  try {
    const val = localStorage.getItem(CONSENT_KEY);
    if (val === "granted" || val === "denied") return val;
  } catch {}
  return null;
};

export const setConsentStatus = (status: Exclude<ConsentStatus, null>) => {
  try {
    localStorage.setItem(CONSENT_KEY, status);
  } catch {}
  window.dispatchEvent(new Event("cookie-consent-change"));
};


export const openCookieSettings = () => {
  window.dispatchEvent(new Event("cookie-consent-open"));
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (getConsentStatus() === null) {
      setVisible(true);
    }
    const open = () => setVisible(true);
    window.addEventListener("cookie-consent-open", open);
    return () => window.removeEventListener("cookie-consent-open", open);
  }, []);


  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "granted");
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-change"));
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "denied");
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-change"));
  };

  if (!visible || isAdminRoute) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6">
      <div className="max-w-3xl mx-auto bg-card border border-border rounded-lg p-5 shadow-2xl">
        <p className="font-[Montserrat] text-sm text-foreground/80 leading-relaxed mb-4 normal-case tracking-normal">
          Wir verwenden Cookies und binden externe Dienste (z.&nbsp;B. YouTube) ein, die Cookies setzen können. 
          Einige sind technisch notwendig, andere helfen uns, die Website zu verbessern. 
          Mehr Informationen finden Sie in unserer{" "}
          <Link to="/datenschutz" className="text-primary hover:underline">
            Datenschutzerklärung
          </Link>.
        </p>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={handleAccept}
            className="px-5 py-2 bg-primary text-primary-foreground font-[Montserrat] text-xs tracking-[0.15em] uppercase rounded hover:bg-primary/90 transition-colors"
          >
            Alle akzeptieren
          </button>
          <button
            onClick={handleDecline}
            className="px-5 py-2 bg-secondary text-foreground font-[Montserrat] text-xs tracking-[0.15em] uppercase rounded border border-border hover:bg-secondary/80 transition-colors"
          >
            Nur notwendige
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
